import { connect } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Hotkey } from 'ui-components/components/hotkey';

import { printTheLabel } from '../../store/scan-to-print/s2p-purchase-and-print.actions';

const messages = defineMessages({
  name: {
    description: 'modalHotkey.reprintLabel',
    defaultMessage: 'Reprint Label',
    id: 'CdG2ip',
  },
});

const mapDispatchToProps = {
  onReprint: printTheLabel,
};

export const ReprintLabelHotkey = ({ children, onReprint }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: ['p'],
      barcode: '+ADOEJDLAS77=',
      hotkey: ['p'],
      // this call reaches "into" the job pipeline
      // from outside of it, and probably shouldn't
      handler: onReprint,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onReprint],
  );

  return <Hotkey hotkey={hotkeyMetadata}>{children}</Hotkey>;
};

ReprintLabelHotkey.propTypes = {
  children: PropTypes.node.isRequired,
  onReprint: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(ReprintLabelHotkey);
